import { createContext, useContext } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { TooltipProvider } from '../components/ui/tooltip';

export const ToastContext = createContext();

export const ToastContextProvider = ({ children }) => {
	const sucesso = (mensagem) => {
		toast.success(`${mensagem}`, {
			position: toast.POSITION.TOP_RIGHT,
			theme: 'dark',
			className: 'toast-container',
		});
	};

	const erro = (mensagem) => {
		toast.error(`${mensagem}`, {
			position: toast.POSITION.TOP_RIGHT,
			theme: 'dark',
			className: 'toast-container',
		});
	};

	const aviso = (mensagem) => {
		toast.warn(`${mensagem}`, {
			position: toast.POSITION.TOP_RIGHT,
			theme: 'dark',
			className: 'toast-container',
		});
	};

	return (
		<ToastContext.Provider value={{ sucesso, erro, aviso }}>
			<TooltipProvider>
				{children}
			</TooltipProvider>
			<ToastContainer />
		</ToastContext.Provider>
	);
};


export const useToast = () => {
	const context = useContext(ToastContext);
	if (!context) {
		throw new Error('useToast deve ser usado dentro de um ToastContextProvider');
	}	
	return context;
};